import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { PostHogService } from '../posthog/posthog.service';

@Directive({
  selector: '[appNavClickTrack]',
})
export class NavClickTrackDirective {
  @Input() menuType: string;
  constructor(
    private el: ElementRef,
    private analyticsService: AnalyticsService,
    private postHogService: PostHogService
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this.trackClickOrigin();
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      // Check if the clicked element is a link
      // const href = target.getAttribute('href');
      // const text = target.textContent.trim();
      const menuLevel1 = target.getAttribute('level1');
      const menuLevel2 = target.getAttribute('level2');
      const menuLevel3 = target.getAttribute('level3');
      this.analyticsService.pushNavClickEvent(
        menuLevel1,
        menuLevel2,
        menuLevel3,
        this.menuType
      );
      // Example: this.analyticsService.trackEvent('click', href, this.menuType);
      this.postHogService.trackCategoryNavigation(
        menuLevel3? menuLevel3 : menuLevel2?menuLevel2:menuLevel1,
        {
          menu_level_1: menuLevel1,
          menu_level_2: menuLevel2,
          menu_level_3: menuLevel3,
          menu_type: this.menuType,
        });
    }
  }

  private trackClickOrigin() { // storing the traffic_source of the click
    this.postHogService.setNextContentAccess({
      traffic_source: 'menu',
    });
  }
}
